export default __webpack_public_path__ + "static/media/delroy.5edd64ca.webp";